import { Button, useTheme } from "@mui/material";
import { tokens } from "../theme/tokens";

const ActionButton = ({
  tone = "gold",
  selected = false,
  size = "medium",
  children,
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const tones = colors.button;

  // backwards compatibility while we migrate
  const aliases = {
    primary: "gold",
    secondary: "teal",
  };

  const resolvedTone = aliases[tone] || tone;

  const toneDef = tones[resolvedTone] || tones.gold;

  const isOutlined =
    props.variant === "outlined" || resolvedTone === "ghost";

  const isActive = selected || !isOutlined;

  return (
    <Button
      {...props}
      size={size}
      sx={{
        minHeight: size === "small" ? 32 : 38,
        px: size === "small" ? 1.4 : 2.2,
        borderRadius: 2,
        fontWeight: 700,
        fontSize: size === "small" ? "0.75rem" : "0.82rem",
        letterSpacing: "0.02em",
        textTransform: "none",
        boxShadow: "none",

        backgroundImage: isActive
          ? "linear-gradient(180deg, rgba(255,255,255,.10), rgba(255,255,255,0))"
          : "none",

        bgcolor: isActive ? toneDef.bg : "transparent",
        color: isActive ? toneDef.color : toneDef.color,
        border: `1px solid ${
          isActive ? toneDef.border : toneDef.border
        }`,

        transition:
          "background-color 180ms ease, border-color 180ms ease, transform 180ms ease, box-shadow 180ms ease",

        "&:hover": {
          bgcolor: toneDef.hoverBg,
          color: toneDef.color,
          borderColor: toneDef.border,
          boxShadow: `0 12px 28px ${toneDef.shadow}`,
          transform: "translateY(-1px)",
        },

        "&.Mui-disabled": {
          bgcolor: colors.surface.elevated,
          color: colors.text.muted,
          borderColor: colors.surface.border,
          backgroundImage: "none",
          boxShadow: "none",
        },

        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default ActionButton;